import { FSharpException } from "./fable_modules/fable-library.3.7.14/Types.js";
import { class_type } from "./fable_modules/fable-library.3.7.14/Reflection.js";
import { equals } from "./fable_modules/fable-library.3.7.14/Util.js";
import { SpriteLayout } from "./Model.fs.js";
import { VSWAP, isShareware } from "./Assets.fs.js";
import { Texture__getPixel, Texture__setPixel } from "./Model.Platform.fs.js";
import { singleton } from "./fable_modules/fable-library.3.7.14/AsyncBuilder.js";
import { loadAsset } from "./Utils.fs.js";

export class MissingGraphicsPackException extends FSharpException {
    constructor() {
        super();
    }
}

export function MissingGraphicsPackException$reflection() {
    return class_type("App.GraphicsCommon.MissingGraphicsPackException", void 0, MissingGraphicsPackException, class_type("System.Exception"));
}

function MissingGraphicsPackException__Equals_229D3F39(this$, obj) {
    if (!equals(this$, null)) {
        if (!equals(obj, null)) {
            if (obj instanceof MissingGraphicsPackException) {
                return 1;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    else if (!equals(obj, null)) {
        return false;
    }
    else {
        return true;
    }
}

export const gamePalette = new Uint32Array([4278190080, 4289200128, 4278233088, 4289243136, 4278190248, 4289200296, 4278211752, 4289243304, 4283716692, 4294726740, 4283759700, 4294769748, 4283716860, 4294726908, 4283759868, 4294769916, 4293717228, 4292664540, 4291875024, 4290822336, 4290032820, 4289243304, 4288190616, 4287401100, 4286348412, 4285558896, 4284769380, 4283716692, 4282927176, 4281874488, 4281084972, 4280295456, 4278190332, 4278190316, 4278190304, 4278190292, 4278190280, 4278190268, 4278190256, 4278190244, 4278190232, 4278190216, 4278190204, 4278190192, 4278190180, 4278190168, 4278190156, 4278190144, 4292401404, 4290296060, 4288453884, 4286348540, 4284243196, 4282401020, 4280295676, 4278190332, 4284262652, 4282423548, 4280322300, 4278221052, 4278217956, 4278214860, 4278211764, 4278209692, 4292410620, 4290313468, 4288478460, 4286381308, 4284283132, 4282447100, 4280349948, 4278252796, 4278245604, 4278240460, 4278234292, 4278230172, 4278224004, 4278217840, 4278211672, 4278206528, 4284284112, 4282449092, 4280351924, 4278254752, 4278248592, 4278242432, 4278236276, 4278230112, 4292410584, 4290313404, 4288478364, 4286381184, 4284284000, 4282448960, 4280351776, 4278254592, 4278254592, 4278250496, 4278247424, 4278244352, 4278241284, 4278238212, 4278235140, 4278232068, 4278228996, 4278224900, 4278221828, 4278218756, 4278215684, 4278212612, 4278209540, 4278206468, 4294769880, 4294769848, 4294769820, 4294507644, 4294769756, 4294769728, 4294769696, 4294769664, 4293190656, 4291611648, 4290032640, 4288453632, 4286874624, 4285558784, 4283979776, 4282400768, 4294753372, 4294750272, 4294748192, 4294745088, 4293168128, 4291591168, 4290014208, 4288437248, 4294760664, 4294753464, 4294745244, 4294738044, 4294729820, 4294721600, 4294714400, 4294706176, 4294705152, 4293656576, 4292870144, 4292083712, 4291297280, 4290510848, 4289724416, 4288937984, 4288151552, 4287102976, 4286316544, 4285530112, 4284743680, 4283957248, 4283170816, 4282384384, 4280821800, 4281655548, 4280603900, 4279815420, 4278763772, 4278236412, 4294713524, 4294705320, 4293132440, 4291559552, 4289986676, 4288413792, 4286840912, 4285530180, 4283957300, 4282384424, 4294760700, 4294752508, 4294745340, 4294737148, 4294728956, 4294721788, 4294713596, 4294705404, 4293132512, 4291559624, 4289986740, 4288413852, 4286840964, 4285530220, 4283957336, 4282384448, 4292667644, 4291879164, 4291090684, 4290565372, 4289776892, 4288988412, 4288462076, 4287674620, 4286623996, 4285572348, 4284521724, 4284257520, 4283993320, 4283730140, 4283465936, 4283202760, 4282939580, 4282675380, 4282411176, 4282148000, 4281884828, 4281621648, 4281358472, 4281094272, 4280831092, 4280567916, 4280303708, 4280040532, 4279777352, 4279775296, 4279512120, 4278984744, 4284743776, 4284769280, 4284506112, 4280025088, 4281073664, 4279247920, 4282908744, 4283433040, 4281597952, 4280032284, 4283190348, 4284243036, 4282400832, 4281348144, 4281611316, 4294243544, 4293454008, 4292664476, 4291348596, 4290822216, 4290032672, 4289769504, 4288979968, 4288190464, 4287400960, 4286874624, 4286348288, 4286085120, 4285821952, 4285558784, 4285295616, 4287103128]);

export function spriteOffsets(vswapView, _arg1, spriteIndex) {
    const firstSprite = vswapView.getUint16(2, true);
    const spriteOffset = vswapView.getUint32(6 + (4 * ((~(~firstSprite)) + spriteIndex)), true);
    const firstColumnOffset = vswapView.getUint16(~(~spriteOffset), true);
    const lastColumnOffset = vswapView.getUint16((~(~spriteOffset)) + 2, true);
    return new SpriteLayout(spriteOffset, firstColumnOffset, lastColumnOffset, (spriteOffset + 4) + (2 * ((lastColumnOffset - firstColumnOffset) + 1)));
}

export function textureStripOffset(_arg1, wallTextureOffset, textureIndex, textureX) {
    return (wallTextureOffset + (4096 * ((isShareware && (textureIndex >= 98)) ? ((56 + textureIndex) - 98) : textureIndex))) + (64 * textureX);
}

export function textureColor(vswapView, _arg1, textureOffset, textureY) {
    const paletteIndex = vswapView.getUint8(textureOffset + textureY);
    return gamePalette[~(~paletteIndex)];
}

export function setPixel(imageData, color, x, y) {
    Texture__setPixel(imageData, color, x, y);
}

export function getPixel(imageData, x, y) {
    return Texture__getPixel(imageData, x, y);
}

export function loadGraphics() {
    return singleton.Delay(() => singleton.Bind(loadAsset(VSWAP), (_arg1) => {
        const vswapResult = _arg1;
        let result;
        if (vswapResult.tag === 1) {
            throw (new MissingGraphicsPackException());
        }
        else {
            const vswapView = new DataView(vswapResult.fields[0]);
            result = [vswapView, ~(~vswapView.getUint32(6, true))];
        }
        return singleton.Return(result);
    }));
}

